import { useTranslation } from "react-i18next";
import { DropdownMenuItem, cn } from "ui";

import { type WorkoutSetTypeOption } from "src/workouts/workoutSetType";

interface WorkoutSetTypeDropdownItemProps {
  option: WorkoutSetTypeOption;
  selected: boolean;
  onSelect: () => void;
}

export function WorkoutSetTypeDropdownItem(
  props: WorkoutSetTypeDropdownItemProps,
) {
  const translation = useTranslation();

  return (
    <DropdownMenuItem
      className={cn(props.selected && "bg-accent font-medium")}
      onSelect={props.onSelect}
    >
      <span
        className={cn("w-4 text-center font-semibold", props.option.className)}
      >
        {props.option.letter}
      </span>
      {translation.t(props.option.labelKey)}
    </DropdownMenuItem>
  );
}
